import Hudson1 from '../../../Media/Ruko Paramount/The Hudson/Hudson (1).webp'
import Hudson2 from '../../../Media/Ruko Paramount/The Hudson/Hudson (2).webp'
import Hudson3 from '../../../Media/Ruko Paramount/The Hudson/Hudson (3).webp'

const Hudsonimages =[
Hudson1,Hudson2,Hudson3
]

export default Hudsonimages;
